export default __webpack_public_path__ + "static/media/logos3.a4ccbd45.png";